import { safeJson } from '@/common/utils/safeJson';
import { useDetailPageStore } from '@/page/detail/store';
import yoda from '@kibt/bridge';
import { useEffect, useRef } from 'react';

interface IInfo {
    uuid: string;
    specImageIndex: number;
    num: number;
    skuId: number;
}

const key = 'DetailBetweenSpecBuy';

export function useListenSpecBuy() {
    // spa下rootTag会共用，因此随机生成一个key
    const uuid = useRef('specBuyUuid_' + Math.random()).current;
    const store = useDetailPageStore();
    useEffect(() => {
        const onEvent = data => {
            if (data) {
                const info: IInfo = typeof data === 'string' ? safeJson<{ bundleId: string }>(data) : data;
                console.log(key, typeof data, data);
                const pageRawData = store.getState().pageRawData;
                if (data.itemId !== pageRawData.itemId) return;
                if (info.uuid === uuid) {
                    const currentSku = pageRawData.skus.find(v => v.skuId === info.skuId);
                    store.setState({
                        // currentSku, TODO: 不生效
                        // purchaseQuantity: info.num,
                        // 提单页中商品列表是将第一个主商品图片作为第一项，
                        // 商详规格图片列表没有算主商品的第一个图片
                        // 因此需要-1
                        specImageIndex: info.specImageIndex - 1,
                        // 顶部的图片swiper 是加了主商品的图片列表，因此需要计算主商品图片列表长度
                        swiperImageIndex: store.getState().showVideo
                            ? info.specImageIndex + (pageRawData.templateImageUrls ?? pageRawData.imageUrls).length
                            : info.specImageIndex + (pageRawData.templateImageUrls ?? pageRawData.imageUrls).length - 1,
                    });
                    store.getState().setCurrentSku(currentSku);
                }
            }
        };

        yoda?.event?.addEventListener?.(key as any, onEvent);
        return () => {
            yoda?.event?.removeEventListener?.(key as any, onEvent);
        };
    }, []);
    return {
        specBuyUuid: uuid,
    };
}
